// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__9xgpW","heroContent":"Hero_heroContent__ZB-XY","fadeIn":"Hero_fadeIn__p3-UK","heroTitle":"Hero_heroTitle__3LjeV","heroSubtitle":"Hero_heroSubtitle__XiHoW"};